import { computed } from 'vue'

import { Participant } from '@collector/sportsapi-client-legacy'
import { queryClient } from '@desktop/queryClient'

import { useParticipantsQuery } from './queries/useParticipantsQuery'
import { useEventId } from './useEventId'

export const useParticipants = () => {
  const eventId = useEventId()
  const { data: participants } = useParticipantsQuery()

  const homeParticipant = computed(() =>
    (participants.value ?? []).find((p) => p.counter === 1),
  )
  const awayParticipant = computed(() =>
    (participants.value ?? []).find((p) => p.counter === 2),
  )

  const setParticipant = (counter: number, participant: Participant) => {
    queryClient.setQueryData<Participant[]>(
      ['event', 'participants', eventId.value],
      (current = []) =>
        current.map((p) => (p.counter === counter ? participant : p)),
    )
  }

  return {
    homeParticipant,
    awayParticipant,
    setHomeParticipant: (home: Participant) => setParticipant(1, home),
    setAwayParticipant: (away: Participant) => setParticipant(2, away),
  }
}
